import template from './delivery_region_routing.create.html';
import controller from './delivery_region_routing.create.controller';
import './delivery_region_routing.create.scss';

let deliveryRegionRoutingCreateComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template,
    controller
}

export default deliveryRegionRoutingCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/create/delivery_region_routing.create.component.js